/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReprocessPayment.ts";

function getPostApiV1IndividualpaymentParcelsParcelidReprocessPaymentUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/reprocess-payment` as const,
  };
  return res;
}

/**
 * @description Dispara uma nova tentativa de cobrança no cartão de recorrência já cadastrado no plano. Exige parcela em aberto (Pendente ou Aguardando Integração), com Nosso Número, método Cartão PecegePay e token/id de recorrência no plano. Retorna 'Registered' quando a cobrança fica em aberto no gateway, 'Paid' quando é aprovada na hora (a parcela é baixada) e 'Failed' quando o cartão recusa. Migrado do legado IndividualPayment/ReprocessPayment — os ramos MundiPagg e AprovaFácil não são suportados (integrações não migradas). **(Requer Authorization para autenticação)**
 * @summary Reprocessa a cobrança de cartão recusada (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reprocess-payment}
 */
export async function postApiV1IndividualpaymentParcelsParcelidReprocessPayment(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidReprocessPaymentUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
